export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserProfile.vue?vue&type=template&id=78799894&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfile.vue?vue&type=template&id=78799894&scoped=true
// module id = 2256
// module chunks = 31